import React, { FC, useContext } from 'react';
import styled from 'styled-components';
import { FBAdSet } from '@/features/editor/widgets/shared/modals/audience/facebook-audience/ad-search/models';
import { Ads } from '@/features/editor/widgets/shared/modals/audience/facebook-audience/ad-search/ads';
import { AdSearchContext } from '@/features/editor/widgets/shared/modals/audience/facebook-audience/ad-search/context';
import {
  adSetHasSelectedChild,
  campaignHasSelectedChild,
  Details,
  ExpandBtn,
  isCampaignTargetedAsWhole,
} from '@/features/editor/widgets/shared/modals/audience/facebook-audience/ad-search/shared';

type Props = {
  adSets: Array<FBAdSet>;
  campaignIdx: number;
  campaignId: string;
};

export const AdSets: FC<Props> = ({ adSets, campaignIdx, campaignId }) => {
  const { setState, state } = useContext(AdSearchContext);
  const isInheritedFromCampaign = isCampaignTargetedAsWhole(
    state.campaigns?.[campaignIdx],
  );
  return (
    <AdSetsContainer>
      {adSets?.map((adSet, idx) => {
        const isSelected =
          isInheritedFromCampaign ||
          adSets[idx]?.isSelected ||
          adSetHasSelectedChild(state, campaignIdx, idx)?.isSelected;
        const onSelect = (isSelected) => {
          setState((draft) => {
            draft.campaigns[campaignIdx].isSelected =
              isSelected || campaignHasSelectedChild(draft, campaignIdx);
            draft.campaigns[campaignIdx].adSets[idx].isSelected = isSelected;
            if (!isSelected)
              draft.campaigns[campaignIdx].adSets?.[idx]?.ads?.forEach((ad) => {
                ad.isSelected = isSelected;
              });
          });
        };
        const { status } = adSet;
        const { name } = adSet;
        const onExpand = () => {
          setState((draft) => {
            draft.campaigns[campaignIdx].adSets[idx].isCollapsed =
              !draft.campaigns[campaignIdx].adSets[idx].isCollapsed;
          });
        };
        const isLast = idx === adSets.length - 1;
        return (
          <AdSetContainer
            isCollapsed={!adSet.isCollapsed}
            key={adSet.name}
            isLast={isLast}
          >
            <AdSetHeader>
              <Details
                defaultValue={isSelected}
                onChange={(value) => onSelect(isInheritedFromCampaign || value)}
                status={status}
                name={name}
                onExpand={onExpand}
              />
              <ExpandBtn onClick={onExpand} isCollapsed={adSet.isCollapsed} />
            </AdSetHeader>
            {!adSet.isCollapsed && (
              <Ads
                ads={adSet.ads}
                adSetIdx={idx}
                campaignIdx={campaignIdx}
                campaignId={campaignId}
                adsetId={adSet.id}
                next={adSet.next}
              />
            )}
          </AdSetContainer>
        );
      })}
    </AdSetsContainer>
  );
};

const AdSetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-size: 1.4rem;
  color: #576470;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.09),
    0 5px 10px 0 rgba(182, 207, 205, 0.24);
  width: 100%;
  padding: 1rem 2rem;
  background-color: #ffffff;
  border: 1px solid #f5f5f5;
  border-radius: 12px;
`;

const AdSetContainer = styled.div`
  ${(p: any) => (p?.isLast ? `` : `margin-bottom: 1rem;`)}
  border-radius: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  background-color: ${(p: { isCollapsed: boolean }) =>
    p?.isCollapsed ? `#ffffff` : ``};
`;
const AdSetsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  background-color: #f5f5f5;
  border-radius: 12px;
  margin: 1rem 2rem;
`;
